import { Image } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import Config from '../../app/config';
import sideMenu from '../../assets/side_menu.svg';
import useTypedParams from '../../hooks/useTypedParams';
import styles from './SideMenuButton.module.css';

const validateUrl = (url: string) => {
  return !url.includes(window.location.host);
};

const SideMenuButton: React.FC = () => {
  const { tenant } = useTypedParams({ tenant: String });
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLIFrameElement>(null);

  window.onmessage = (e: { data: string }) => {
    if (e.data === 'close') {
      setOpen(false);
    }
  };

  const onClick = useCallback(() => {
    setOpen((oldState) => !oldState);
  }, []);

  useEffect(() => {
    if (open && ref !== null && ref.current !== null) {
      ref.current.focus();
    }
  }, [ref, open]);

  return (
    <>
      {Config.REACT_APP_AUTH_DOMAIN && validateUrl(Config.REACT_APP_AUTH_DOMAIN) ? (
        <>
          <Image
            className={styles.logo}
            src={`${Config.REACT_APP_STATIC_URL}${sideMenu}`}
            preview={false}
            onClick={onClick}
          />
          <div className={styles.container}>
            <iframe
              title="side-menu"
              height="100%"
              width="15%"
              className={styles.iframe}
              src={`${Config.REACT_APP_AUTH_DOMAIN}${tenant}/side_menu/`}
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-popups-to-escape-sandbox"
              frameBorder="0"
              allowFullScreen
              hidden={!open}
              ref={ref}
              onBlur={() => setOpen(false)}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default SideMenuButton;
